<div class="sigma_preloader" [ngClass]="windowLoad ? 'hidden':''">
    <img src="assets/img/logo.png" alt="preloader" class="me-3">
    <div class="d-flex logo-container_name">
        <span>{{'father' | translate}}</span>
        <span>{{'bishoy' | translate}}</span>
        <span>{{'kamel' | translate}}</span>
    </div>
</div>